module.exports = "## Drop Down Menu\n\nThe `DropDownMenu` component is Material-UI's implementation of the \n[Textfield dropdown](https://www.google.com/design/spec/components/menus.html#menus-usage).\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/DropDownMenu/README.md
 ** module id = 982
 ** module chunks = 0
 **/